import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';

const DefaultContent = () => {
  return (
    <>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Skeleton variant="rounded" height={300} />
        </Grid>
        <Grid size={1}>
          <Skeleton variant="rounded" height={60} />
        </Grid>
        <Grid size={11}>
          <Skeleton variant="rounded" height={60} />
        </Grid>
        <Grid size={8}>
          <Skeleton variant="rectangular" height={20} />
        </Grid>
        <Grid size={4}>
          <Skeleton variant="rectangular" height={20} />
        </Grid>
        <Grid size={8}>
          <Skeleton variant="rectangular" height={20} />
        </Grid>
        <Grid size={4}>
          <Skeleton variant="rectangular" height={20} />
        </Grid>
        <Grid size={8}>
          <Skeleton variant="rectangular" height={20} />
        </Grid>
        <Grid size={4}>
          <Skeleton variant="rectangular" height={20} />
        </Grid>
      </Grid>
    </>
  );
};

export default DefaultContent;
